import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { disconnectionInfoModal } from "./disconnectionInfoModal.component";
import { MobileDisconnectionInfoModalComponent } from "../mobile-disconnection-info-modal/mobile-disconnection-info-modal.component";

export function showDisconnectionInfoModal(modalService: NgbModal, mobileMode: string = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileDisconnectionInfoModalComponent: disconnectionInfoModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<disconnectionInfoModal>m.componentInstance);
    return modal;
}
